import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full rounded-lg border bg-card px-3 py-2 text-body text-t1 placeholder:text-t3',
        'focus-visible:outline-none transition-colors duration-press ease-out-strong',
        'focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas',
        'disabled:cursor-not-allowed disabled:text-t3',
        'resize-y min-h-[88px]',
        invalid
          ? 'border-crit focus-visible:border-crit'
          : 'border-line-2 focus-visible:border-line-3',
        className,
      )}
      {...rest}
    />
  );
});
